import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Title,
  CheckboxContainer,
  CheckboxInput,
  CheckboxLabel,
  CheckIcon,
} from './styles/EnquiryFormCheckbox.styled';

export default function EnquiryFormCheckbox({ title, value, setValue, options }) {
  return (
    <Container>
      <Title>{title}</Title>
      {options.map((label) => (
        <CheckboxContainer>
          <CheckboxInput checked={value === label} onClick={() => setValue(label)}>
            <CheckIcon checked={value === label} />
          </CheckboxInput>
          <CheckboxLabel>{label}</CheckboxLabel>
        </CheckboxContainer>
      ))}
    </Container>
  );
}

EnquiryFormCheckbox.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.string,
  required: PropTypes.string,
  options: PropTypes.string,
}.isRequired;
